import { useCallback, useState } from 'react';

export function useForceRender() {
  const [, updateState] = useState<Record<string, never>>();

  const forceRender = useCallback(() => updateState({}), []);
  return forceRender;
}
